"use strict";

var _defineProperty = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ApiError = /*#__PURE__*/function (_Error) {
  _inherits(ApiError, _Error);

  var _super = _createSuper(ApiError);

  function ApiError(type) {
    var _this;

    var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, ApiError);

    _this = _super.call(this, type);
    _this.type = type;
    _this.error = null;
    _this.errors = {};

    if (response) {
      if (response.error) {
        _this.error = response.error;
      } else if (response.errors) {
        _this.errors = response.errors.reduce(function (result, error) {
          return Object.assign({}, result, _defineProperty({}, error.path, error.type));
        }, {});
      }
    }

    return _this;
  }

  _createClass(ApiError, null, [{
    key: "isApiError",
    value: function isApiError(err) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var result = typeof err === 'object' && err && err instanceof this;

      if (result && type) {
        result = err.type === type;
      }

      return result;
    }
  }]);

  return ApiError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.ApiError = ApiError;

(function (ApiError) {
  var Types;

  (function (Types) {
    Types["BadRequest"] = "bad request";
    Types["Unauthorized"] = "unauthorized";
    Types["Forbidden"] = "forbidden";
    Types["NotFound"] = "not found";
    Types["Failed"] = "failed";
  })(Types = ApiError.Types || (ApiError.Types = {}));
})(ApiError = exports.ApiError || (exports.ApiError = {}));